import * as XLSX from 'xlsx';
import { EncuestaRecord, interpretarSUS } from './encuesta';

const PREGUNTAS_LABELS: Record<string, string> = {
  p1: 'Usaría este sistema frecuentemente',
  p2: 'El proceso fue innecesariamente complejo',
  p3: 'El formulario fue fácil de completar',
  p4: 'Necesité ayuda para completar el registro',
  p5: 'Las secciones estaban bien organizadas',
  p6: 'Encontré demasiadas inconsistencias',
  p7: 'La mayoría aprendería a usarlo rápidamente',
  p8: 'El formulario fue incómodo de usar',
  p9: 'Me sentí seguro completando el registro',
  p10: 'Tuve que aprender muchas cosas antes de usarlo',
};

export const downloadExcelEncuesta = (records: EncuestaRecord[]): void => {
  // Hoja 1: Respuestas individuales
  const rowsDetalle = records.map((r) => ({
    'Fecha': new Date(r.fecha_registro).toLocaleString('es-BO'),
    'Email': r.email_usuario,
    'P1 - Usaría frecuentemente (1-5)': r.p1,
    'P2 - Innecesariamente complejo (1-5)': r.p2,
    'P3 - Fácil de completar (1-5)': r.p3,
    'P4 - Necesité ayuda (1-5)': r.p4,
    'P5 - Bien organizado (1-5)': r.p5,
    'P6 - Demasiadas inconsistencias (1-5)': r.p6,
    'P7 - Mayoría aprendería rápido (1-5)': r.p7,
    'P8 - Incómodo de usar (1-5)': r.p8,
    'P9 - Me sentí seguro (1-5)': r.p9,
    'P10 - Tuve que aprender mucho (1-5)': r.p10,
    'Puntaje SUS (0-100)': r.puntaje_sus,
    'Interpretación SUS': interpretarSUS(r.puntaje_sus),
    'Comentarios': r.comentario || '',
  }));

  // Hoja 2: Resumen estadístico
  const totalEncuestas = records.length;
  const promSUS = totalEncuestas > 0
    ? Math.round(records.reduce((acc, r) => acc + r.puntaje_sus, 0) / totalEncuestas)
    : 0;

  const promediosPorPregunta = Object.keys(PREGUNTAS_LABELS).map((key) => {
    const vals = records.map((r) => r[key as keyof EncuestaRecord] as number);
    const prom = vals.length > 0 ? (vals.reduce((a, b) => a + b, 0) / vals.length).toFixed(2) : '0';
    return {
      'Pregunta': `${key.toUpperCase()} - ${PREGUNTAS_LABELS[key]}`,
      'Promedio (1-5)': prom,
    };
  });

  const rowsResumen = [
    { 'Métrica': 'Total de encuestas', 'Valor': totalEncuestas },
    { 'Métrica': 'Puntaje SUS promedio (0-100)', 'Valor': promSUS },
    { 'Métrica': 'Interpretación general', 'Valor': interpretarSUS(promSUS) },
    { 'Métrica': '', 'Valor': '' },
    { 'Métrica': '--- Distribución por categoría ---', 'Valor': '' },
    { 'Métrica': 'Excelente (85-100)', 'Valor': records.filter((r) => r.puntaje_sus >= 85).length },
    { 'Métrica': 'Bueno (71-84)', 'Valor': records.filter((r) => r.puntaje_sus >= 71 && r.puntaje_sus < 85).length },
    { 'Métrica': 'Aceptable (51-70)', 'Valor': records.filter((r) => r.puntaje_sus >= 51 && r.puntaje_sus < 71).length },
    { 'Métrica': 'Deficiente (35-50)', 'Valor': records.filter((r) => r.puntaje_sus >= 35 && r.puntaje_sus < 51).length },
    { 'Métrica': 'Inaceptable (0-34)', 'Valor': records.filter((r) => r.puntaje_sus < 35).length },
  ];

  const workbook = XLSX.utils.book_new();

  const wsDetalle = XLSX.utils.json_to_sheet(rowsDetalle);
  wsDetalle['!cols'] = [
    { wch: 22 }, { wch: 32 }, { wch: 30 }, { wch: 30 }, { wch: 30 },
    { wch: 30 }, { wch: 30 }, { wch: 30 }, { wch: 30 }, { wch: 30 },
    { wch: 30 }, { wch: 30 }, { wch: 18 }, { wch: 20 }, { wch: 50 },
  ];
  XLSX.utils.book_append_sheet(workbook, wsDetalle, 'Respuestas individuales');

  const wsResumen = XLSX.utils.json_to_sheet(rowsResumen);
  wsResumen['!cols'] = [{ wch: 40 }, { wch: 20 }];
  XLSX.utils.book_append_sheet(workbook, wsResumen, 'Resumen estadístico');

  const wsPromedios = XLSX.utils.json_to_sheet(promediosPorPregunta);
  wsPromedios['!cols'] = [{ wch: 60 }, { wch: 18 }];
  XLSX.utils.book_append_sheet(workbook, wsPromedios, 'Promedios por pregunta');

  const wbout = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
  const blob = new Blob([wbout], {
    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  });
  const url = URL.createObjectURL(blob);
  const date = new Date().toISOString().split('T')[0];
  const anchor = document.createElement('a');
  anchor.href = url;
  anchor.download = `encuesta_satisfaccion_upal_${date}.xlsx`;
  document.body.appendChild(anchor);
  anchor.click();
  document.body.removeChild(anchor);
  URL.revokeObjectURL(url);
};
